import { useEffect, useState } from 'react'
import { useDebouncedCallback } from 'use-debounce'
import { appApi, useShowBadgesMutation } from 'src/app/appApiQueries'
import { selectShowBadges } from 'src/app/hostSettings'
import { useAppSelector } from './useRTK'
import { usePrevious } from './usePrevious'

// This hook follows any changes made to the host settings within the redux store and debounces those changes before sending them off to the backend s3 bucket
export function useUpdateShowBadges() {
  const { data } =
    appApi.endpoints.getHostSettings.useQueryState('hostSettings')
  const showBadges = useAppSelector(selectShowBadges)
  const [updateShowBadges] = useShowBadgesMutation()
  const [debouncedShowBadges, setDebouncedShowBadges] = useState(showBadges)
  const debouncedShowBadgesFn = useDebouncedCallback((value: boolean) => {
    setDebouncedShowBadges(value)
  }, 1000)
  const prevDebouncedShowBadges = usePrevious<boolean>(debouncedShowBadges)

  useEffect(() => {
    debouncedShowBadgesFn(showBadges)
  }, [showBadges, debouncedShowBadgesFn])

  // listen to the debounced changes before firing off mutation
  useEffect(() => {
    // only begin to send off updates once the host settings are first obtained
    // only send updates if showBadges changed (activeSession is updated in the backend)
    if (data && debouncedShowBadges !== prevDebouncedShowBadges) {
      updateShowBadges(debouncedShowBadges)
    }
  }, [debouncedShowBadges, updateShowBadges, data, prevDebouncedShowBadges])
}
